module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (152).4da69c5a.jpg";